import { configureStore } from "@reduxjs/toolkit";
import { appApi } from "./slices/appApi";
import uiReducer from "./slices/uiSlice";
import builderMessageReducer from "./slices/builderMessageSlice";
// InsertReducerImport
import filter from "./slices/FilterState";
import modal from "./slices/ModalState";
import activeRow from "./slices/ActiveRowState";
import "./slices/databaseSlice";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    builderMessage: builderMessageReducer,
    // InsertReducerProperty
  filter,
  modal,
  activeRow,
    [appApi.reducerPath]: appApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
